import React from "react";
import { Helmet } from "react-helmet";

const ChatBotScript = () => {
  return (
    <Helmet>
      <script
        src="https://freeform.chat/static/scripts/embed.js"
        async=""
        data-type="trigger"
        data-trigger-bg-color="#ffffff"
        data-trigger-icon-color="#000000"
        data-trigger-icon-type="chat"
        data-conversation-id="tomo-lead-gen"
      />
    </Helmet>
  );
};

export default ChatBotScript;
